export default "__VITE_ASSET__D0iARX1Y__"